import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import { InputAdornment } from '@mui/material';
import { translate } from '@utils';
import { AnswerQueryInterface, HeadCell, MgState } from '@types';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { setAnswerFiltersPartially } from '@actions/answersPageAction';
import '../index.scss';

interface FilterByNameProps {
  data: HeadCell;
}

export const FilterByName: FC<FilterByNameProps> = ({ data }) => {
  const dispatch = useDispatch();
  const answersFilter = useSelector<MgState, AnswerQueryInterface>(
    ({ answersPage }) => answersPage.filters
  );

  return (
    <TextField
      className="search-container"
      autoFocus
      value={answersFilter[data.filterKeys[0]] || ''}
      onChange={(e) => {
        dispatch(setAnswerFiltersPartially({ [data.filterKeys[0]]: e.currentTarget.value }));
      }}
      placeholder={translate('search')}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {answersFilter[data.filterKeys[0]] && (
              <CloseIcon
                onClick={() => {
                  dispatch(setAnswerFiltersPartially({ [data.filterKeys[0]]: '' }));
                }}
                className="close-icon"
              />
            )}
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};
